module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/comparatoreele/comparatoreele.component.scss
// module id = ./src/app/comparatoreele/comparatoreele.component.scss
// module chunks = main